import React, { useState, useEffect, ReactNode } from 'react';
import { ThemeContext, Theme } from './ThemeContextType';

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  // Récupérer le thème depuis le localStorage ou utiliser le thème sombre par défaut
  const [theme, setTheme] = useState<Theme>(() => {
    const savedTheme = localStorage.getItem('theme');
    return (savedTheme === 'light' ? 'light' : 'dark') as Theme;
  });

  // Mettre à jour le localStorage lorsque le thème change
  useEffect(() => {
    localStorage.setItem('theme', theme);
    // Mettre à jour la classe sur l'élément body pour appliquer le thème globalement
    document.body.className = `theme-${theme}`;
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'dark' ? 'light' : 'dark');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};